<template>
	<!-- 一级客户管理-->
	<div class="public_Spacing systemCorporateAccount">
		<div class="pulbic_oparetionBlock">
			<div class="public_criteriaRange customerManagementPC-select">
				<div class="public_oparetionBlock_Menu">
					<label class="public_lbSty">客户名称：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="firstEnterprise" filterable>
						<el-option v-for="item in options" :key="item.value" :label="item.ORMTB400CA00" :value="item.ORMTB400ID"></el-option>
					</el-select>
				</div>
			</div>
			<div class="public_operatArea" style="margin-left: 0;">
				<div class="public_operatBtn" style="margin-left: 0;">
					<el-button class="public_saleWater_chaxun" type="primary" @click="cusquerList(),cusquerSelectList()" id="查询" >
						<i class="iconfont icon-chaxun"></i>查询
					</el-button>
					<!-- <el-button class="public_saleWater_daochu" type="primary"   id="导出" @click="">
						<i class="iconfont icon-daochu"></i>导出
					</el-button> -->
					<el-button class="public_saleWater_xinzeng" type="primary"  id="新增"  @click="newlyAdd">
						<i class="iconfont icon-tianjia1"></i>新增
					</el-button>
				</div>
			</div>
		</div>

		<div class="pulbic_oparetionBlock pulbic_table_container">
			<el-table :data="tableData" style="width: 100%" stripe max-height="90%" class="public_tableColumn"
			 :header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}">
				<el-table-column align="center" prop="ORMTB400CA00" label="客户名称"></el-table-column>
				<el-table-column align="center" prop="ORMTB400CA01" label="客户简称"></el-table-column>
				<el-table-column align="center" prop="ORMTB400CA02" label="手机号"></el-table-column>
				<el-table-column align="center" prop="ORMTB400CA03" label="客户代码"></el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope" >
						<div style="text-align: center;">
							<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info" v-if=""
							 size="small" @click="cusSetUpClick(scope.row),cusCode=scope.row.ORMTB400CA03" >
								客户设置
							</el-button>
							<el-button class="public_icon_qiyong public_icon_width public_icon_margin" type="info" v-if=""
							 size="small" @click="modify(scope.row)" >
								修改
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage"
				 :page-sizes="[10, 20, 30, 40]" :page-size="limitMo" layout="total,sizes, prev, pager, next" :total="pagingPageMo"></el-pagination>
			</div>
		</div>

		<!-- 新增 -->
		<div class="public-dialog">
			<el-dialog title="新增" :visible.sync="insertShow" width="28%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="100" v-model="cusInsertObj.ORMTB400CA00" placeholder="请输入客户名称">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户简称<span> </span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="20" v-model="cusInsertObj.ORMTB400CA01" placeholder="请输入客户简称">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">手机号<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="11" v-model="cusInsertObj.ORMTB400CA02" placeholder="请输入手机号">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户代码<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="4" @keyup="cuscodeInput" v-model="cusInsertObj.ORMTB400CA03" placeholder="请输入客户代码">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="cusInsertClick">保存</el-button>
						<el-button type="warning" @click="insertShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<!-- 修改 -->
		<div class="public-dialog">
			<el-dialog title="编辑" :visible.sync="updateShow" width="30%" :closeOnClickModal='false'>
				<div class="systemCorporateAccount-dialog">
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户名称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="100" v-model="cusUpdateObj.ORMTB400CA00" placeholder="请输入客户名称">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户简称<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="20" v-model="cusUpdateObj.ORMTB400CA01" placeholder="请输入客户简称">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">手机号<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="11" v-model="cusUpdateObj.ORMTB400CA02" placeholder="请输入手机号">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-li">
						<div class="SCADL-text">客户代码<span>*</span></div>
						<div class="SCADL-input">
							<input type="text" maxlength="4" v-model="cusUpdateObj.ORMTB400CA03" placeholder="请输入客户代码" readonly="readonly">
						</div>
					</div>
					<div class="systemCorporateAccount-dialog-btn">
						<el-button type="primary" @click="cusUpdateClick">保存</el-button>
						<el-button type="warning" @click="updateShow=false">取消</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
		<div class="public-dialog">
			<el-dialog title="客户设置" :visible.sync="cusSetUp" fullscreen >
				<el-tabs tab-position="left" style="height: auto;" v-model="activeName" @tab-click="handleTabClick">
					<el-tab-pane label="用户管理"><systemUsers v-if="tabRefresh.systemUsers" :cusCode="cusCode" :cusid="cusid"></systemUsers></el-tab-pane>
					<el-tab-pane label="角色管理"><systemRoles v-if="tabRefresh.systemRoles" :cusCode="cusCode" :cusid="cusid"></systemRoles></el-tab-pane>
					<el-tab-pane label="全局参数"><systemGlobals v-if="tabRefresh.systemGlobals" :cusCode="cusCode" :cusid="cusid"></systemGlobals></el-tab-pane>
				</el-tabs>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import systemGlobals from './salesBigCustomers/systemGlobal';
	import systemUsers from './salesBigCustomers/systemUser';
	import systemRoles from './salesBigCustomers/systemRole';
	
	export default {
		components:{
			systemGlobals:systemGlobals,
			systemUsers:systemUsers,
			systemRoles:systemRoles,
		},
		data() {
			return {
				pertb005List: this.$store.state.uobj.pertb005, //登陆缓存--用户信息
				firstEnterprise:'',
				options:[],
				cusStatus:'',
				cusStatusList:[],
				tableData: [], //列表table数据--查询
				materList:[],
				cusUpdateObj:{
					ORMTB400CA00:'',
					ORMTB400CA01:'',
					ORMTB400CA02:'',
					ORMTB400CA03:'',
				},
				cusInsertObj:{
					ORMTB400CA00:'',
					ORMTB400CA01:'',
					ORMTB400CA02:'',
					ORMTB400CA03:'',
				},
				// 新增
				insertShow: false,
				// 修改
				updateShow:false,
				bindingShow:false,
				materShow:false,
				materInsertShow:false,
				materupdateShow:false,
				cusSetUp:false,
				cusCode:'',
				cusid:'',
				activeName: "0",
				tabRefresh:{
					systemUsers:true,
					systemRoles:false,
					systemGlobals:false,
				},
				pageMo: 1, //默认列表页码
				limitMo: 10, //每页的条数
				pagingPageMo: 0, //分页--数据列表共有的条数
				currentPage: 1, //设置当前页默认为1
				solelist: [],
				// 历史缓存
				currentUrl: this.$route.path,
				historyInfo: "",
			};
		},
		created() {
			var list = "";
			list = this.$store.state.solelist;
			var path = this.$route.path;
			if (path === "/SalesystemCorporateAccount") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			this.pertb005List = this.$store.state.uobj.pertb005;
			// 赋值，缓存销毁
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl));
			sessionStorage.removeItem(this.currentUrl);
			if (this.historyInfo != null && this.historyInfo != "") {
				// this.init();
			}
		},
		mounted() {
			this.cusquerList()
			this.cusquerSelectList()
		},
		// 存储数据
		beforeDestroy() {
			var obj = {
				currentPage: this.currentPage, //当前页数
				pageMo: this.pageMo, //页码
				limitMo: this.limitMo, //每页条数
			};
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj));
		},
		methods: {
			init() {
				this.currentPage = this.historyInfo.currentPage;
				this.pageMo = this.historyInfo.pageMo;
				this.limitMo = this.historyInfo.limitMo;
			},
			cusSetUpClick(row){
				this.cusCode=row.ORMTB400CA03
				this.cusid=row.ORMTB400ID
				this.cusSetUp=true
			},
			cusquerSelectList(){
				this.tableData =[]
				var url="orm/ormtb400/selectOrmtb400List"
				var postData = {}
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.options=res.data.data
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
				}).catch(()=>{
				})
			},
			cusquerList(){
				this.tableData =[]
				// this.pagingPageMo =0
				var url="orm/ormtb400/selectPageList"
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					ORMTB400ID: this.firstEnterprise, //客户名称
					page: this.pageMo,
					limit: this.limitMo
				}
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data;
						this.pagingPageMo = res.data.count;
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			handleTabClick: function(tab, event){
			    switch (this.activeName) {
			        case '0':
			            this.switchTab('systemUsers')
			            break;
			        case '1':
			            this.switchTab('systemRoles')
			            break;
			        case '2':
			            this.switchTab('systemGlobals')
			            break;
			        default:
			    }
			},
			switchTab: function(tab) {
			    for (let [key, value] of Object.entries(this.tabRefresh)) {        
			        if (key == tab) {
			            this.tabRefresh[key] = true
			        } else {
			            this.tabRefresh[key] = false
			        }
			    }
			},
			newlyAdd(){
				this.insertShow=true
			},
			cusUpdateClick(){
				if(this.cusUpdateObj.ORMTB400CA00.trim().length==0) return this.$message.error('请输入客户名称')
				var reQ =/^1[3-9][0-9]{9}$/;
				if(!reQ.test(this.cusUpdateObj.ORMTB400CA02)) return this.$message.error('请输入有效手机号')  
				var url="orm/ormtb400/updateOrmtb400"
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData =this.cusUpdateObj
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message.success('修改成功')
						this.cusquerList()
						this.cusquerSelectList()
						this.updateShow=false
						this.cusUpdateObj={
							ORMTB400CA00:'',
							ORMTB400CA01:'',
							ORMTB400CA02:'',
							ORMTB400CA03:'',
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			cusInsertClick(){
				if(this.cusInsertObj.ORMTB400CA00.trim().length==0) return this.$message.error('请输入客户名称')
				var reQ =/^1[3-9][0-9]{9}$/;
				if(!reQ.test(this.cusInsertObj.ORMTB400CA02)) return this.$message.error('请输入有效手机号')  
				var reg = /^\d{4}$/;
				if(!reg.test(this.cusInsertObj.ORMTB400CA03)) return this.$message.error('请输入四位有效客户代码')
				var url="orm/ormtb400/insertOrmtb400"
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData =this.cusInsertObj
				this.axios.post(url, postData).then(res => {
					console.log(res)
					if (res.data.code == 200) {
						this.$message.success('新增成功')
						this.cusquerList()
						this.cusquerSelectList()
						this.insertShow=false
						this.cusInsertObj={
							ORMTB400CA00:'',
							ORMTB400CA01:'',
							ORMTB400CA02:'',
							ORMTB400CA03:'',
						}
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(()=>{
						loading.close()
					},300)
				}).catch(()=>{
					loading.close()
				})
			},
			
			modify(row){
				this.updateShow=true
				var str=JSON.stringify(row)
				this.cusUpdateObj=JSON.parse(str)
				console.log(this.cusUpdateObj)
			},
			handleSizeChange(val){
				this.limitMo=val;
				this.pageMo=1;
				this.pageList();
				this.cusquerSelectList()
			},
			handleCurrentChange(val){
				this.pageMo=val;
				this.pageList();
				this.cusquerSelectList()
			},
			XAdd(){
				
			},
			cuscodeInput(){
				this.cusInsertObj.ORMTB400CA03=this.clearNoNum(this.cusInsertObj.ORMTB400CA03)
			},
			clearNoNum(value) { //清除数字以外的字符
				value = value.replace(/[^\d]/g, ""); //清除“数字”和“.”以外的字符
				value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
				return value;
			},
		},
	};
</script>

<style scoped>
	.systemCorporateAccount {
		background-color: #f3f3f3;
	}

	.test111:active {
		background-color: red !important;
	}

	.systemCorporateAccount-display,
	.systemCorporateAccount-wuliao-input {
		display: flex;
		flex-direction: row;
		align-items: center !important;
	}

	.systemCorporateAccount-optionSty {
		width: 140px;
		margin-right: 30px;
	}

	.systemCorporateAccount-wuliao-input>input {
		height: 40px;
		box-sizing: border-box;
		border: 1px solid #dcdfe6;
		border-radius: 5px;
		padding-left: 5px;
	}
	.systemCorporateAccount-dialog{
		padding: 0 20px;
	}
	.systemCorporateAccount-dialog-li{
		display: flex;
		box-sizing: border-box;
	}
	.systemCorporateAccount-dialog-li+.systemCorporateAccount-dialog-li{
		margin-top: 20px;
	}
	.SCADL-text{
		height: 30px;
		line-height: 30px;
		flex:.35;
		font-size: 18px;
		color: #333;
	}
	.SCADL-text span{
		color: red;
	}
	.SCADL-input{
		flex:1;
		box-sizing: border-box;
	}
	.SCADL-input input{
		height: 30px;
		line-height: 30px;
		width: 99.9%;
		padding-left: 10px;
		border:1px solid #999;
		color: #333;
		font-size: 18px;
		border-radius: 5px;
		box-sizing: border-box;
	}
	.SCADL-input .el-select{
		width: 99.9%;
	}
	.SCADL-input .el-input__inner{
		height: 30px;
		line-height: 30px;
	}
	.systemCorporateAccount-dialog-btn{
		text-align: center;
		margin-top: 40px;
	}
	.systemCorporateAccount-dialog-li
	.CADL-binding-input{
		border: none;
		outline: none;
	}
	.SCADL-btn input{
		display: inline-block;
		width: 65%;
	}
	.SCADL-btn .el-button{
		height: 30px;
		line-height: 30px;
		padding: 0 20px;
	}
	.systemCorporateAccount-dialog-operation-btn{
		margin-top: 20px;
	}
	.systemCorporateAccount-dialog .pulbic_oparetionBlock{
		padding-left: 0;
		padding-right: 0;
	}
	.systemCorporateAccount-dialog-operation-btn .el-button:last-child{
		background-color: #ffaa00;
	}
</style>

